exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:769px){#forms-module-section .fb-sidebar[data-v-0cbb6c0b]{border-right:1px solid #000}}@media screen and (max-width:768px){#forms-module-section .fb-sidebar[data-v-0cbb6c0b]{border-bottom:1px solid #000}}", ""]);

// exports
